import React from 'react';
import Investor from '../../models/Investor';

export interface AdvisorInvestorContextType {
  investors: Investor[] | null;
  refreshInvestor: (id: string) => void;
  refreshUnreadCount: () => void;
  eligibleInvestors: () => Investor[] | null;
  eligibleInvestorsCount: () => number;
  loading: () => boolean;
  unreadUpdatesCount: () => number | '10+';
}

const AdvisorInvestorContext = React.createContext<AdvisorInvestorContextType>({
  investors: null,
  refreshInvestor: () => {},
  refreshUnreadCount: () => {},
  eligibleInvestors: () => null,
  eligibleInvestorsCount: () => 0,
  loading: () => false,
  unreadUpdatesCount: () => 0 as number | '10+',
});

export default AdvisorInvestorContext;
